import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { Trans } from "react-i18next";

function SuccessModal({ trainingUnit, waitingListPosition, onClose }) {
  return (
    <Modal open={true} size="tiny" onClose={onClose}>
      <Modal.Header as="h1" color="blue">
        {trainingUnit.courseDate.course.title}
      </Modal.Header>
      <Modal.Content>
        {waitingListPosition > 0 ? (
          <Trans
            i18nKey="coursePlan.registration.events.onWaitingList"
            values={[waitingListPosition]}
          />
        ) : (
          <Trans i18nKey="coursePlan.registration.events.registered" />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>
          <Trans i18nKey="coursePlan.registration.actions.ok" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

SuccessModal.displayName = "coursePlan/register/SuccessModal";

export default React.memo(SuccessModal);
